import { useFocusEffect } from "expo-router";
import React from "react";
import { useTranslation } from "react-i18next";
import { Text, View, SafeAreaView, ActivityIndicator } from "react-native";

import Congratulations from "@/assets/congratulations.svg";
import Logo from "@/assets/logo.svg";
import Copyright from "@/components/Copyright";
import Title from "@/components/Title";
import ButtonLogout from "@/components/button/ButtonLogout";
import { storage } from "@/context/storage";
import { sendRequest } from "@/utils/ApiUtil";

export default function Finish() {
  const { t } = useTranslation();

  useFocusEffect(
    React.useCallback(() => {
      const interval = setInterval(() => {
        updateStatus();
      }, 20000);

      return () => clearInterval(interval);
    }, [])
  );

  const submitApplication = async () => {
    const applicationId = storage.getString("user.auth.applicationId");

    if (applicationId) {
      await sendRequest("post", "/submit-application", { applicationId }, true);
    }
  };

  const updateStatus = async () => {
    const applicationId = storage.getString("user.auth.applicationId");

    if (applicationId) {
      const request = await sendRequest(
        "get",
        "/application-status",
        { applicationId },
        true
      );

      if (request.status === "READY_FOR_SUBMISSION") {
        submitApplication();
      }
    }
  };

  return (
    <SafeAreaView className="grow bg-white1">
      <View className="z-50 absolute top-0 right-0 m-8">
        <ButtonLogout />
      </View>
      <View className="items-center justify-center w-full h-full">
        <View className="items-center h-5/6 w-full">
          <Logo className="m-2" />
          <View className="m-2">
            <Title text={t("onboarding/finish:title")} />
          </View>
          <View className="m-4 items-center">
            <Congratulations />
            <View className="my-4 items-center">
              <Text className="text-center text-lg text-darkergray mb-4">
                {t("onboarding/finish:analysing")}
              </Text>
              <ActivityIndicator size="large" color="#5D0CBA" />
            </View>
          </View>
        </View>
        <View className="flex-grow justify-end items-end h-1/6">
          <Copyright />
        </View>
      </View>
    </SafeAreaView>
  );
}
